"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Actions_vue_1 = __importDefault(require("../../../Common/Actions.vue"));
const { ArrowUp, MapPin, Copy, ClipboardCopy } = require('lucide-vue-next');
let Proposal = class Proposal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.id = 0;
        this.indexLocation = 0;
        this.idAction = 0;
        this.activePaste = false;
        this.locationCopy = {};
        this.locationActive = -1;
    }
    pasteConfig(locationPaste) {
        this.$emit('openModalCopyConfig', this.locationCopy, locationPaste);
        this.locationActive = -1;
        this.activePaste = false;
    }
    copyConfig(location) {
        this.locationCopy = location;
        this.activePaste = true;
        if (this.locationActive === location.id) {
            this.activePaste = false;
            return (this.locationActive = -1);
        }
        else {
            this.locationActive = location.id;
        }
    }
    setView(value) {
        this.$emit('setView', value);
    }
    setLocations(value) {
        this.$emit('setLocations', value);
    }
    updated() {
        // console.log(this.arrLocations);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Proposal.prototype, "proposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Proposal.prototype, "arrLocations", void 0);
Proposal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { ArrowUp, MapPin, Copy, Actions: Actions_vue_1.default, ClipboardCopy },
    })
], Proposal);
exports.default = Proposal;
